import { Link, useSearch } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@/components/ui/misc';
import { api, isApiError } from '@/lib/api';
import { describeError } from '@/lib/errors';
import { AuthLayout } from './auth-layout';
import { PasswordForm } from './password-form';

export function ResetPasswordPage() {
  const { t } = useTranslation();
  const { token } = useSearch({ from: '/reset-password' });
  const [done, setDone] = useState(false);

  const submit = async (newPassword: string) => {
    try {
      await api('/auth/reset-password', { method: 'POST', body: { token, newPassword } });
      setDone(true);
    } catch (err) {
      throw new Error(
        isApiError(err) && err.status === 410 ? t('auth.tokenExpired') : describeError(err, t),
      );
    }
  };

  return (
    <AuthLayout title={t('auth.resetTitle')}>
      {!token ? (
        <Alert variant="error">{t('auth.tokenExpired')}</Alert>
      ) : done ? (
        <Alert>{t('auth.resetDone')}</Alert>
      ) : (
        <PasswordForm submitLabel={t('auth.resetPassword')} onSubmit={submit} />
      )}
      <p className="mt-4 text-center text-sm">
        <Link to="/login" search={{}} className="text-primary underline-offset-4 hover:underline">
          {t('auth.backToSignIn')}
        </Link>
      </p>
    </AuthLayout>
  );
}
